<template>
  <v-card-text>
    <v-switch
        label="Nadpisuj lokalizacje wypełnionego pola przy aktualizacji"
        :input-value="options.overwriteFields"
        @change="update({overwriteFields: $event})"
    ></v-switch>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "geolocation-options",
  data(){
    return {
      onOpeningForm: false,
      onSendingForm: true,
      onSign: false,
    }
  },
  created(){
    this.onSendingForm = true
  },
  mixins: [ options ]
}
</script>
<style>
</style>
